import "./questionnaire.scss";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

// components
import QuestionnaireAppBar from '../../../../components/QuestionnaireAppBar/QuestionnaireAppBar'
import QuestionnaireAppBarSmall from '../../../../components/QuestionnaireAppBarSmall/QuestionnaireAppBarSmall'
import QuestionnaireQuestionForm from '../../../../components/QuestionnaireQuestionForm/QuestionnaireQuestionForm'
import ActionsPlannedDrawer from "../../../../components/ActionsPlannedDrawer/ActionsPlannedDrawer";

const Questionnaire = () => {
  const [searchParams] = useSearchParams();
  const showAction = searchParams.get("show-action");
  const [actionDrawer, setActionDrawer] = useState<boolean>(false);
  
  const toggleActionDrawer = () =>{
    setActionDrawer(prev => !prev)
  }

  useEffect(()=>{
    if(showAction === "true"){
      setActionDrawer(true)
    }else{
      setActionDrawer(false)
    }
    // eslint-disable-next-line
  },[showAction])

  return (
    <div className='questionnaire'>
      <QuestionnaireAppBar toggleDrawer={toggleActionDrawer}/>
      <QuestionnaireAppBarSmall toggleDrawer={toggleActionDrawer}/>
      <div className="bodyContainer">
      <QuestionnaireQuestionForm  />
      <ActionsPlannedDrawer
        actionDrawer={actionDrawer}
        toggleDrawer={toggleActionDrawer}
      />
      </div>
    </div>
  )
}

export default Questionnaire